export let state = {
    organizationTreeItems: [],
    organizationTreePlaceholder: [],
    prevOrganizationTreeItems: [],
    prevOrganizationTreePlaceholder: [],
    sourceItem: {},
    destinationItem: {},
    sourceItemIdAndType: null,
    destinationItemIdAndType: null,
    asideBarHasChanged: false,
    latestFullTree: [],
    isSearchActive: false
}
